import { action, computed, makeAutoObservable, observable } from 'mobx';
import { DateTimeRangePropsType, RangeType } from './DateTimeRange';
import { DateTime } from 'src_common/utils/time/time';

export class DateTimeRangeState {
    @observable private dateRange: RangeType = {
        startDate: DateTime.current().subtractDays(7).toISOString(),
        endDate: DateTime.current().toISOString(),
    };

    public constructor(private readonly props: DateTimeRangePropsType) {
        makeAutoObservable(this);
        this.dateRange = {
            startDate: this.props.value.startDate,
            endDate: this.props.value.endDate,
        };
    }

    @computed public get startDateValue(): string | undefined {
        return this.dateRange.startDate;
    }

    @computed public get endDateValue(): string | undefined {
        return this.dateRange.endDate;
    }

    @action public handleChange = (value: RangeType): void => {
        if (this.props.onChange !== undefined) {
            this.props.onChange(value);
        }
    };

    @action public changeStartDate = (startDate: string | null): void => {
        this.dateRange = {
            startDate: startDate ?? undefined,
            endDate: this.dateRange.endDate,
        };
        this.handleChange(this.dateRange);
    };

    @action public changeEndDate = (endDate: string | null): void => {
        this.dateRange = {
            startDate: this.dateRange.startDate,
            endDate: endDate ?? undefined,
        };
        this.handleChange(this.dateRange);
    };
}
